import { ThemeColor } from '@/enums'
import { isNumber } from '@/utils'
import { useMemo } from 'react'
import { Flex } from '../../styled'
import { Typography } from '../Typography'
import { StyledButton } from './styles'

interface ButtonProps extends React.ComponentProps<typeof StyledButton> {
  children: React.ReactNode
}

const Button = ({ children, ...rest }: ButtonProps) => (
  <StyledButton {...rest}>
    <Typography color={ThemeColor.b50} variant="button">
      {children}
    </Typography>
  </StyledButton>
)

export interface PlusMinusProps {
  value: number | string
  onChange: (value: number) => void
  min?: number
  max?: number
}

export const PlusMinus = ({ value, onChange, min, max }: PlusMinusProps) => {
  const minDisabled = useMemo(
    () => !isNumber(value) || (isNumber(min) && value <= min),
    [min, value],
  )
  const maxDisabled = useMemo(
    () => isNumber(max) && isNumber(value) && value >= max,
    [max, value],
  )

  const handleMinusClick = () => {
    if (minDisabled) return
    const parsedValue = typeof value === 'string' ? parseFloat(value) : value
    onChange((parsedValue || 0) - 1)
  }

  const handlePlusClick = () => {
    if (maxDisabled) return
    const parsedValue = typeof value === 'string' ? parseFloat(value) : value
    onChange((parsedValue || 0) + 1)
  }

  return (
    <Flex gap="8px">
      <Button disabled={minDisabled} onClick={handleMinusClick}>
        -
      </Button>
      <Button disabled={maxDisabled} onClick={handlePlusClick}>
        +
      </Button>
    </Flex>
  )
}
